<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <!-- Filing Id + validation (adjusted) -->
<div class="relative w-full sm:w-auto">
  <input
    type="text"
    name="filingId"
    placeholder="Search by filing Id"
    [(ngModel)]="filingId"
    #filingIdCtrl="ngModel"
    pattern="^[0-9]*$"
    inputmode="numeric"
    (keydown)="preventSpaceKey($event)"
    (keydown.enter)="onSearch()"
    class="border-b text-sm border-gray-400 focus:outline-none
           focus:border-[#001529] px-1 py-1 placeholder-gray-400"
  />

  <span
    *ngIf="filingIdCtrl.invalid && (filingIdCtrl.dirty || filingIdCtrl.touched)"
    class="
      absolute left-0 top-full mt-1
      text-red-600 text-xs
      z-50
      max-w-[220px]
      break-words
      leading-tight
    "
  >
    Filing ID must be an integer.
  </span>
</div>
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="issuerName"
    type="text"
    placeholder="Search by issuer name"
    class="border-b-1 text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
  />
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="insiderName"
    type="text"
    placeholder="Search by insider name"
    class="border-b-1 text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
  />
</div>
<div class="mb-4"></div>

<!-- Relationship Dialog -->
<!--<p-dialog-->
<!--  header="Enter Relationship"-->
<!--  [(visible)]="showRelationshipDialog"-->
<!--  [style]="{width: '400px'}"-->
<!--  [modal]="true"-->
<!--  [closable]="false"-->
<!--  [closeOnEscape]="false">-->

<!--  <div class="p-fluid">-->
<!--    <div class="p-field">-->
<!--      <label for="relationshipInput" class="block mb-2">Relationship</label>-->
<!--      <p-dropdown-->
<!--        id="relationshipInput"-->
<!--        [options]="relationshipOptions"-->
<!--        [(ngModel)]="relationshipInput"-->
<!--        optionLabel="label"-->
<!--        optionValue="value"-->
<!--        placeholder="Select relationship"-->
<!--        [appendTo]="'body'"-->
<!--        class="w-full"-->
<!--      ></p-dropdown>-->
<!--    </div>-->
<!--  </div>-->

<!--  <ng-template pTemplate="footer">-->
<!--    <button-->
<!--      pButton-->
<!--      type="button"-->
<!--      label="Cancel"-->
<!--      class="p-button-text"-->
<!--      (click)="showRelationshipDialog = false">-->
<!--    </button>-->
<!--    <button-->
<!--      pButton-->
<!--      type="button"-->
<!--      label="Submit"-->
<!--      (click)="onDialogSubmit()">-->
<!--    </button>-->
<!--  </ng-template>-->
<!--</p-dialog>-->

<p-table
  [value]="processedNonIndividualRelationshipEntries"
  [paginator]="processedNonIndividualRelationshipEntries.length > 0"
  [first]="first"
  (onLazyLoad)="loadData($event)"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="isLoading"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [(selection)]="selectedTag"
  dataKey="entryId"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template #header>
    <tr>
      <!--      <th style="width: 4rem">-->
      <!--        <p-tableHeaderCheckbox />-->
      <!--      </th>-->
      <th>Filing Id</th>
      <th>Trading Plan Id</th>
      <th>Issuer Name</th>
      <th>Insider Name</th>
      <th>Insider Type</th>
      <th>Form Link</th>
      <th>Relationship to Issuer</th>
      <th>Action</th>
    </tr>
  </ng-template>
  <ng-template #body let-share>
    <tr
      [ngClass]="{
          'highlight-plan-row': share.tradingPlanStatus === 'DUPLICATE'
        }"
    >
      <!--      <td>-->
      <!--        <p-tableCheckbox [value]="share" />-->
      <!--      </td>-->
      <td>
        <a
          *ngIf="share.filingId; else empty"
          [href]="
            '/inbox?filingId=' +
            share.filingId +
            '&filingState=' +
            share.filingState
          "
          [style.color]="'#4a90e2'"
          [style.cursor]="'pointer'"
          [style.text-decoration]="'underline'"
          rel="noopener"
          target="_blank"
          >{{ share.filingId }}</a
        >

        <ng-template #empty>
          <span>-</span>
        </ng-template>
      </td>
      <td>{{ share.planId || "N/A" }}</td>

      <td>{{ share.issuerName || "N/A" }}</td>
      <td>{{ share.insiderName || "N/A" }}</td>
      <td>{{ share.insiderType || "N/A" }}</td>

      <td>
        <a
          href="{{ share.sourceLink }}"
          *ngIf="share.sourceLink"
          target="_blank"
          >Link</a
        >

        <span *ngIf="!share.sourceLink">-</span>
      </td>
      <!--      <td>{{ share.issuerRelationship || "N/A" }}</td>-->
      <!--      <td>-->
      <!--        <button-->
      <!--          class="bg-white text-black border border-gray-400 rounded py-1 px-3 transition-colors duration-200"-->
      <!--          (click)="onUpdateClick(share)"-->
      <!--        >-->
      <!--          Update-->
      <!--        </button>-->
      <!--      </td>-->
      <td>
        <p-dropdown
          [options]="relationshipOptions"
          [(ngModel)]="share.issuerRelationship"
          optionLabel="label"
          optionValue="value"
          placeholder="Select relationship"
          [appendTo]="'body'"
          class="w-full"
          filter="true"
          filterBy="label"
        ></p-dropdown>
      </td>
      <td>
        <button
          class="bg-white text-black border border-gray-400 rounded py-1 px-3 transition-colors duration-200 cursor-pointer hover:bg-[#2a334a] hover:text-white"
          (click)="onUpdateClick(share)"
          [disabled]="share.issuerRelationship === share.originalRelationship"
        >
          Update
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>

<ng-container
  *ngIf="!isLoading && processedNonIndividualRelationshipEntries.length === 0"
>
  <div class="text-center py-6 text-gray-500">No record found</div>
</ng-container>

<p-toast></p-toast>
